module.exports = __webpack_public_path__ + "img/goods13_2.1f1c68b7.jpg";